/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {PropertyConfigurator} from "../../property_configurator/views/PropertyConfigurator";
const route = [{bundlerEntry: "propertyConfigurator", path: rpAppPath.propertyConfigurator, component: PropertyConfigurator}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {PropertyConfigurator} from "../../property_configurator/views/PropertyConfigurator";
const route = [{bundlerEntry: "propertyConfigurator", path: rpAppPath.propertyConfigurator, component: PropertyConfigurator}];

(function () {
    rpClient(route);
})();
